import PropTypes from "prop-types";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { z } from "zod";

import { Spinner } from "@/components/ui/spinner";
import { BaseForm, FormCombobox } from "components/BaseForm";
import TwilioPhoneNumberService from "services/TwilioPhoneNumber";
import VoicemailService from "services/Voicemails";

const schema = z.object({
  voicemail_id: z.number().nullable(),
});

const AssignVoicemailForm = ({
  twilioPhoneNumberId,
  voicemailId,
  onSuccess,
}) => {
  const { data: voicemails = [], isLoading } = useQuery({
    queryKey: ["voicemails-for-filter"],
    queryFn: () => VoicemailService.getVoicemailsForFilter(),
  });

  const options = useMemo(
    () =>
      voicemails.map(({ id, name }) => ({ key: id, value: id, text: name })),
    [voicemails]
  );

  if (isLoading) {
    return (
      <div className="tw:flex tw:items-center tw:justify-center tw:p-6">
        <Spinner />
      </div>
    );
  }

  const handleSubmit = async ({ voicemail_id }) => {
    await TwilioPhoneNumberService.assignVoicemail(
      twilioPhoneNumberId,
      voicemail_id || null
    );
  };

  const handleSuccess = () => {
    toast.success("Voicemail assigned");
    onSuccess?.();
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={{ voicemail_id: voicemailId ?? null }}
      onSubmit={handleSubmit}
      onSuccess={handleSuccess}
      submitButtonText="Save"
    >
      <FormCombobox
        name="voicemail_id"
        label="Voicemail"
        options={options}
        placeholder="Select voicemail"
        clearable
      />
    </BaseForm>
  );
};

AssignVoicemailForm.propTypes = {
  twilioPhoneNumberId: PropTypes.number.isRequired,
  voicemailId: PropTypes.number,
  onSuccess: PropTypes.func.isRequired,
};

export default AssignVoicemailForm;
